import { zeros18 } from './zeros18';

export const zip18s = (arrayToZip: string[]) => {
  return zeros18.map((zero, index) => arrayToZip[index] || zero);
};
